import React from "react";  
import { useLocation } from "react-router-dom";  
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import ButtonsSection from '../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection';  
import NoteTable from '../../common_nextgen/common_components/NoteScreenComponents/NoteTable';  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import useCouponPatientPayGpiListNote from "./hooks/useCouponPatientPayGpiListNote";  
import { useMemo,useCallback } from "react";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants.js";

  
const CouponPatientPayGpiListNote = () => {  
    const location = useLocation();  
    const { state: stateVal } = location;
    const [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    const {
        selectedSchedules = [],
      previousScreen = ROUTE_PATHS.OUT_OF_POCKET_MAX_SCHEDULE,
      currentIndex: initialIndex = 0,
    } = currentState;
    console.log(
      "states",
      stateVal,
      currentState,
      selectedSchedules,
      initialIndex,
      previousState
    );const navigateToPage = useCustomNavigate();  
  
    const {  
        notes,  
        newNotes,  
        mode,  
        first,  
        rows,  
        totalRecords,  
        currentIndex,  
        setMode,  
        setFirst,  
        setRows,  
        setCurrentIndex,  
        handleSaveNotes,  
        handleChangeNewNote,  
        onPageChange,  
        exportAsCSV  
    } = useCouponPatientPayGpiListNote(selectedSchedules, initialIndex);  
  
    const screen_title = "Coupon Patient Pay GPI List Note";  
    const screen_code = "RCCLN001";  
  
    const columns = mode === 'view'  
        ? [  
            { key: 'clnNote', header: 'Note' },  
            { key: 'chgDate', header: 'Added Date' },  
            { key: 'chgTime', header: 'Added Time' },  
            { key: 'chgUserName', header: 'User' }  
        ]  
        : [  
            { key: 'clnNote', header: 'Note' }  
        ];  
  
        const handleBack =useCallback(() => {
            if (currentIndex < selectedSchedules.length - 1) {
              setCurrentIndex(currentIndex + 1);
            } else {
              navigateToPage(previousScreen, previousState);
            }
          }, [currentIndex, navigateToPage, setCurrentIndex]);
          
          const handleBackAndSetMode = useCallback(() => {
            handleBack();
            setMode("view");
          }, [handleBack, setMode]);
      
          const handleModeSwitch = useCallback(() => {
            if (mode === "add") {
              setMode("view");
            } else if (mode === "view") {
              setMode("add");
            }
          }, [mode]);
  
          const leftButtons = useMemo(
            () => [
              {
                button_label: "Back",
                button_handeler: handleBackAndSetMode,
                button_key: "F12",
              },
              ...(mode === "add"
                ? [
                    {
                      button_label: "View Note",
                      button_handeler: handleModeSwitch,
                      button_key: "F6",
                    },
                  ]
                : []),
            ],
            [mode, handleBackAndSetMode, handleModeSwitch]
          );
      
          const rightButtons = useMemo(
            () => [
              ...(mode === "view"
                ? [
                    {
                      button_label: "Add Note",
                      button_handeler: handleModeSwitch,
                      button_key: "F6",
                    },
                  ]
                : []),
              { button_label: "Export as CSV", button_handeler: exportAsCSV },
            ],
            [mode]
          );    
  
    const getName = (selectedSchedules, currentIndex) => (  
        <>  
            <strong> Schedule  </strong>  
            {selectedSchedules[currentIndex].cpfGpiListName}  
            <span className="info-records">
           <strong>    Description  </strong>
        {selectedSchedules[currentIndex].cpfGpiListDescription}
      </span> 
              </>  
    );  
  
    return (  
        <div className="container">  
            <ButtonsSection ctaButtons={leftButtons} align="left" />  
            <div className="left-aligned-section">  
                <div className="header-section">  
                    <h1>  
                        {screen_title} - <span className="heading-cod">{screen_code}</span>  
                    </h1>  
                </div>  
                <p className="head-name">{getName(selectedSchedules, currentIndex)}</p>  
            </div>  
            <div className="button-sections">  
                <ButtonsSection ctaButtons={rightButtons} align="right" />  
            </div>  
            <NoteTable  
                data={notes}  
                columns={columns}  
                mode={mode}  
                newNotes={newNotes}  
                handleChangeNewNote={handleChangeNewNote}  
                handleSaveNotes={handleSaveNotes}  
            />  
            <NextGenPaginator  
                first={first}  
                rows={rows}  
                totalRecords={totalRecords}  
                currentPage={first / rows}  
                rowsPerPageOptions={[10, 25, 50]}  
                onPageChange={onPageChange}  
            />  
        </div>  
    );  
};  
  
export default CouponPatientPayGpiListNote;  
